import React from 'react'
import Weather from 'components/Weather'

const WeatherPage = () => {
  return <Weather />
}

export default WeatherPage
